import { useParams } from "react-router-dom";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";

import {
  Clinic_1,
  Clinic_2,
  Clinic_3,
  Clinic_4,
  Clinic_5,
  Clinic_6,
  Clinic_7,
  Clinic_8,
  Clinic_9,
  Clinic_10,
  Clinic_11,
  Clinic_12,
  Clinic_13,
  Clinic_14,
  Clinic_15,
} from "../../inc/DataClinic";

// **สร้าง Object Mapping Component**
const clinicComponents = {
  1: Clinic_1,
  2: Clinic_2,
  3: Clinic_3,
  4: Clinic_4,
  5: Clinic_5,
  6: Clinic_6,
  7: Clinic_7,
  8: Clinic_8,
  9: Clinic_9,
  10: Clinic_10,
  11: Clinic_11,
  12: Clinic_12,
  13: Clinic_13,
  14: Clinic_14,
  15: Clinic_15,
};

export default function Page() {
  const { id } = useParams();
  const SelectedClinic = clinicComponents[id]; // เลือก component ตาม id

  return (
    <>
      <Navbar />
      <DropdownMenu />
      
      <div className="max-w-5xl mx-auto container h-full ">
        {SelectedClinic ? <SelectedClinic /> : <span>ไม่พบข้อมูล</span>}
      </div>
      <Footer />
    </>
  );
}
